import React from "react";

const STYLES = {
  assigned: "bg-slate-100 text-slate-700 ring-slate-200",
  accepted: "bg-sky-100 text-sky-900 ring-sky-200",
  en_route: "bg-blue-100 text-blue-900 ring-blue-200",
  arrived: "bg-amber-100 text-amber-900 ring-amber-200",
  in_progress: "bg-indigo-100 text-indigo-900 ring-indigo-200",
  completed: "bg-emerald-100 text-emerald-900 ring-emerald-200",
  issue_reported: "bg-red-100 text-red-900 ring-red-200",
  cancelled: "bg-rose-100 text-rose-700 ring-rose-200",
};

export function StatusBadge({ status, testId }) {
  const value = String(status || "assigned").toLowerCase();
  return (
    <span data-testid={testId} className={`inline-flex items-center rounded-full px-2.5 py-1 text-[11px] font-semibold ring-1 ring-inset ${STYLES[value] || STYLES.assigned}`}>
      {value.replace(/_/g, " ")}
    </span>
  );
}